// KK (Kalite Kontrol) Agent + Prompt Library şemaları — spec §3/§4.
import { z } from "zod";

export const QC_PROMPT_TYPES = ["rewrite", "critique"] as const;
export type QcPromptType = (typeof QC_PROMPT_TYPES)[number];

export const QC_STATUSES = ["queued", "running", "ready", "failed"] as const;
export type QcStatus = (typeof QC_STATUSES)[number];

// KK promptlarında çözümlenen placeholder alt kümesi (spec §3.1) — library
// editöründeki "bilinmeyen token" uyarısı bu listeye karşı çalışır.
export const QC_PLACEHOLDER_TOKENS = [
  "company_name",
  "sector",
  "company_size",
  "reporting_year",
  "current_date",
  "section_code",
  "section_label",
] as const;

export const QcIssueSchema = z.object({
  severity: z.enum(["high", "medium", "low"]),
  quote: z.string(),
  issue: z.string(),
  suggestion: z.string(),
  quoteVerified: z.boolean().optional(), // worker set eder (spec §5.1)
});
export type QcIssue = z.infer<typeof QcIssueSchema>;

export interface QcMeta {
  promptId: string;
  promptName: string;
  promptType: QcPromptType;
  model: string;
  provider: string;
  tokensTotal: number;
  costUsd: number;
  coverageRatio: number | null;
  coverageMissing: string[] | null;
  issues: QcIssue[] | null;
  sourceContentHash: string;
  generatedAt: string;
}

export const QcPromptCreateSchema = z.object({
  name: z.string().min(3).max(120),
  description: z.string().max(1000).optional().nullable(),
  promptType: z.enum(QC_PROMPT_TYPES).default("rewrite"),
  promptText: z.string().min(10).max(20_000), // max: token bombası önlemi (CEO S3)
  isActive: z.boolean().default(true),
  sortOrder: z.number().int().min(0).default(0),
});
export type QcPromptCreate = z.infer<typeof QcPromptCreateSchema>;

export const QcPromptUpdateSchema = QcPromptCreateSchema.partial();
export type QcPromptUpdate = z.infer<typeof QcPromptUpdateSchema>;

export interface QcPromptDto {
  id: string;
  name: string;
  description: string | null;
  promptType: QcPromptType;
  promptText: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export const QcStartRequestSchema = z.object({ qcPromptId: z.string().uuid() });
export type QcStartRequest = z.infer<typeof QcStartRequestSchema>;

export const QcRejectRequestSchema = z.object({
  reason: z.string().max(500).optional(),
});
export type QcRejectRequest = z.infer<typeof QcRejectRequestSchema>;
